import React from "react";
import { Viewer } from "@react-pdf-viewer/core";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";

const PdfDisplay = ({ fileUrl }) => {

  const pageNavigationPluginInstance = pageNavigationPlugin();
  const { GoToNextPage, GoToPreviousPage } = pageNavigationPluginInstance;

  return (
    <div>
      <div className="pdf-viewer-container">
        <div className="pdf-viewer">
          <Viewer
            fileUrl={fileUrl}
            plugins={[pageNavigationPluginInstance]}
          />
        </div>
        <div
          style={{
            alignItems: "center",
            backgroundColor: "#eee",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            padding: "4px"
          }}
        >
          <div style={{ padding: "5px 10px" }}>
            <GoToPreviousPage>
              {props => (
                <button
                  className="pdf-nav-button"
                  style={{
                    backgroundColor: props.isDisabled
                      ? "rgba(238,129,85,0.5)"
                      : "#EE8155",
                    border: "none",
                    color: "black",
                    borderRadius: "10vw",
                    cursor: props.isDisabled
                      ? "not-allowed"
                      : "pointer",
                    fontSize: "1.3rem",
                    padding: "2px 10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  disabled={props.isDisabled}
                  onClick={props.onClick}
                >
                  {'<'}
                </button>
              )}
            </GoToPreviousPage>
          </div>
          <div style={{ padding: "5px 10px" }}>
            <GoToNextPage>
              {props => (
                <button
                  className="pdf-nav-button"
                  style={{
                    backgroundColor: props.isDisabled
                      ? "rgba(238,129,85,0.5)"
                      : "#EE8155",
                    border: "none",
                    borderRadius: "10vw",
                    fontSize: "1.3rem",
                    color: "black",
                    cursor: props.isDisabled
                      ? "not-allowed"
                      : "pointer",
                    padding: "2px 10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  disabled={props.isDisabled}
                  onClick={props.onClick}
                >
                  {'>'}
                </button>
              )}
            </GoToNextPage>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfDisplay;
